import { Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { FirestoreService } from '../firestore-service.service';
import { FileUpload } from '../container';
import { UploadService } from '../upload.service';
import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import { ConfirmingDialogComponent } from '../confirming-dialog/confirming-dialog.component';
import { firstValueFrom } from 'rxjs';
import { SearchService } from '../search.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
    selector: 'app-uploadpopup',
    templateUrl: './uploadpopup.component.html',
    styleUrls: ['./uploadpopup.component.scss'],
    standalone: true,
    imports: [
      CommonModule, 
      MatDialogModule, 
      FormsModule,
      ConfirmingDialogComponent,
      PdfViewerModule
    ]
})
export class UploadpopupComponent {
  pdfSrc: any
  textContent = ""
  textTitle = ""
  fileType = ""
  fileSize = 0
  userId = ""
  triedUpload = false
  loaderMessage = "Loading document, please wait..."
 // isLoadingLabelVisible = false
  contentKey = ""
  organizationKey = ""
  projectKey = ""
  projectName = ""
  contentType = ""
  doAddCover = false
  objectType = ""
  file: File = new File([], "")
  fileKey = ""
  dialogConfirmingRef: any
  showPDFPreview = false
  coverImageURL = ""
  userImageUpload = false
  isQuestionAboutAudioTranscription = false
  doMakeAudioTranscription = false
  removeAudioFileAfterTranscription = true
  maxFileSize = 400000000 // 400MB in bytes allowed for file upload
  maxFileSizeForTranscription = 20000000 // 10MB in bytes allowed for file upload without the need to remove it after transcription

  constructor(public dialogRef: MatDialogRef<UploadpopupComponent>, private dialog: MatDialog, private firestore: FirestoreService, @Inject(MAT_DIALOG_DATA) public data: {userId: string, contentKey: string, documentKey: string, file: File, organizationKey: string, projectKey: string, contentType: string, doAddCover: boolean, objectType: string, projectName: string, coverImageURL: string, userImageUpload: boolean, isQuestionAboutAudioTranscription: boolean, doMakeAudioTranscription: boolean, removeAudioFileAfterTranscription: boolean, textContent: string, fileType: string}, private uploadService: UploadService, private searchService: SearchService) { 
    this.userId = data.userId
    this.contentKey = data.contentKey
    this.projectKey = data.projectKey
    this.projectName = data.projectName
    this.organizationKey = data.organizationKey
    this.contentType = data.contentType
    this.doAddCover = data.doAddCover
    this.objectType = data.objectType
    this.file = data.file
    this.userImageUpload = data.userImageUpload
    this.isQuestionAboutAudioTranscription = data.isQuestionAboutAudioTranscription || false
    this.doMakeAudioTranscription = data.doMakeAudioTranscription || false
    this.removeAudioFileAfterTranscription = data.removeAudioFileAfterTranscription || true
  }

  ngAfterViewInit() {
    this.initiate()
  }

  async initiate() {
    if (typeof (FileReader) !== 'undefined') {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
        this.textTitle = this.file.name
        if (this.fileType == "text/plain") {
          this.textContent = reader.result as string
          this.textContent = this.trimTextContent(this.textContent)
        }
      }, (error: any) => {
        console.error("error", error)
        this.firestore.showSnackBar("Error reading file. Please try again.")
        this.dialogRef.close(false)
      }
      this.textTitle = this.file.name
      this.fileType = this.file.type
      this.fileSize = this.file.size
      if (this.fileType == "text/plain") { // if plain text was uploaded
        reader.readAsText(this.file);
      } else  if (this.fileType == "application/doc") {
        reader.readAsArrayBuffer(this.file);
      } else if (this.fileType == "application/pdf") { // if pdf was uploaded
        reader.readAsArrayBuffer(this.file);
      } else if (this.fileType == "image/png" || this.fileType == "image/jpg" || this.fileType == "image/jpeg") { // if image was uploaded
        reader.readAsArrayBuffer(this.file);
      } else if (this.fileType.startsWith("application/vnd.openxmlformats-officedocument") || this.fileType.startsWith("application/msword") || this.fileType.startsWith("application/vnd.ms-excel") || this.fileType.startsWith("application/vnd.ms-powerpoint")) { // if office was uploaded
        reader.readAsArrayBuffer(this.file);
      } else if (this.fileType.startsWith('audio') || this.fileType.startsWith('video')) { // if audio or video was uploaded
        if (this.fileSize > this.maxFileSizeForTranscription) { // for bigger audio and video files, we will transcribe them to text and then remove them after transcription
          this.firestore.showSnackBar("The file is too big to be stored. It will be transcribed to text, and then removed after transcription.")
          this.removeAudioFileAfterTranscription = true
          this.doMakeAudioTranscription = true
        } else { // for smaller audio and video files, we will ask user if they want to transcribe them to text
        this.firestore.showSnackBar("Audio and video files can be transcribed to text.")
        if (this.isQuestionAboutAudioTranscription == false) {
          this.isQuestionAboutAudioTranscription = true
          this.data.isQuestionAboutAudioTranscription = true
          const result = await firstValueFrom(this.dialog.open(ConfirmingDialogComponent, {
            data: {"content": "Do you want to transcribe this file to text and remove it after storing transcription?", "onlyCloseButton": false}
          }).afterClosed());
          this.doMakeAudioTranscription = result
          this.data.doMakeAudioTranscription = result
          this.data.removeAudioFileAfterTranscription = result
          this.removeAudioFileAfterTranscription = result
          }
        }
      } else {
        console.error("file type not supported", this.fileType)
        this.firestore.showSnackBar("Try to select office, text, audio, image or video files only.")
      }
    }
    
    this.uploadFile(this.file, this.contentKey, "", this.projectName, this.fileType)
  }


  dataURLtoFile(dataurl: any, filename: string) {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    }

  afterLoadComplete(pdfData: any) { // launched when pdf loading completed
    this.loaderMessage = "File has been uploaded, extracting its content..."
    this.getPDFText(pdfData).then((pages)=> {
        this.textContent = ""
        pages.forEach(page => {
          page.forEach(txt => {
            this.textContent += txt.str + " "
          })
        })
        if (this.textContent.length > 900000) {
          this.textContent = this.textContent.substring(0, 900000)
          this.firestore.showSnackBar("Text content of the file has been truncated to 900000 characters.")
        }
        if (this.textContent == "") {
          this.firestore.showSnackBar("Unable to read content of this file.")
        }

      })
    }

  getFileType(file: File) {
    if(file.type.match('image.*'))
      return 'image';
    if(file.type.match('video.*'))
      return 'video';
    if(file.type.match('audio.*'))
      return 'audio';
    return 'other';
  }

  async getPageText(pdf: any, pageNo: number) {
    const page = await pdf.getPage(pageNo);
    const tokenizedText = await page.getTextContent();
    let ret = [];
    for (let i = 0; i < tokenizedText.items.length; i++) {
      ret.push({
        str: tokenizedText.items[i].str,
        page: pageNo,
        index: i
      });
    }
    return ret;
  };

  async getPDFText(pdf: any) {
    const maxPages = pdf.numPages;
    const pageTextPromises = [];
    for (let pageNo = 1; pageNo <= maxPages; pageNo += 1) {
      pageTextPromises.push(this.getPageText(pdf, pageNo));
    }
    const pageTexts = await Promise.all(pageTextPromises);
    return pageTexts;
  };


    async uploadCoverFile(file: File, fileKey: string) {
      if (file) {
        return new Promise<void>((resolve, reject) => {
          let currentFileUpload = new FileUpload(file, file.name, this.contentKey);
          currentFileUpload.url = ""; // this.objectKey
          const uploadTask = this.uploadService.pushFileToStorage(this.userId, fileKey, currentFileUpload, this.organizationKey);
          
          uploadTask.on(
            'state_changed',
            (snapshot) => {
              //const percentage = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            },
            (error) => {
              console.error(error.code);
              reject(error); // Reject the promise if there's an error
            },
            async () => {
              try {
                this.coverImageURL = uploadTask.snapshot.metadata.fullPath; // Upload completed successfully
                const storage = getStorage();
                const imageRef = ref(storage, this.coverImageURL);
                const result = await getDownloadURL(imageRef);
                
                // Update Firestore after getting the download URL
                await this.firestore.updateContentCoverImage(this.organizationKey, this.contentKey, result);
                await this.firestore.updateCoverImage(this.organizationKey, this.contentKey, this.coverImageURL, fileKey);
                resolve(); // Resolve the promise when everything is done
              } catch (error) {
                reject(error); // Reject the promise if something goes wrong
              }
            }
          );
        });
      } else {
        throw new Error("File is not defined");
      }
    }

  async uploadFile(file: File, documentKey: string, coverImageFileKey: string, projectName: string, fileType: string) {
    const fileSize = file.size
    if (fileSize > this.maxFileSize) {
      this.firestore.showSnackBar("The file is too big for uploading. Contact us at hello@prodely.com to increase the limit.")
      this.removeAudioFileAfterTranscription = true
      this.doMakeAudioTranscription = true
      this.dialogRef.close(false)
      return
    }
    const url = "organizations/"+this.organizationKey+"/images/"+documentKey// "/users/"+this.userId+"/docs/"+file.name // path to file in storage is: /ORGANIZATIONS/<ORGKEY>/IMAGES/<CONTENTKEY>
    await this.firestore.checkIfFileExists(url).then(async fileExists => {
      if (fileExists == true && documentKey != "" && documentKey != undefined) {
        this.dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
          //width: '400px',
          data: {"content": "This file has already been uploaded by you.", "onlyCloseButton": true}
        });
        this.dialogConfirmingRef.afterClosed().subscribe(() => { // if file was already added, leave popup after showing message
          this.dialogRef.close(false)
        })
      } else { // if file was not added, show pdf component in html and therefore start creating preview
        this.showPDFPreview = true
        if (file) {
          let currentFileUpload = new FileUpload(file, file.name, this.contentKey);
          currentFileUpload.url = ""
          const uuid = this.firestore.generateUID() // I need to generate unique id for file in storage, because file name can be the same for different files
          const uploadTask = this.uploadService.pushFileToStorage(this.userId, uuid, currentFileUpload, this.organizationKey)
          const storage = getStorage();
          const imageRef = ref(storage, (await uploadTask).metadata.fullPath);
          const downloadURL = await getDownloadURL(imageRef)
          let percentage = 0
          uploadTask.on('state_changed',
            (snapshot) => {
              percentage = Math.round(snapshot.bytesTransferred / snapshot.totalBytes)*100; // Track progress of file upload
            },
            (error) => {
              console.error("error uploading file", error)
              // A full list of error codes is available at
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case 'storage/unauthorized':
                  console.error(error)
                  // User doesn't have permission to access the object
                  console.error("User doesn't have permission to access the object")
                  this.dialog.open(ConfirmingDialogComponent, {
                    data: {"content": "Uploaded file is too big. Currently maximum size is 2MB. Contact as at hello@prodely.com to increase the limit.", "onlyCloseButton": true}
                  });
                  this.loaderMessage = "Uploaded file is too big."
                  this.firestore.showSnackBar("Uploaded file is too big. Currently maximum size is 2MB. Contact as at hello@prodely.com to increase the limit.")
                  break;
                case 'storage/canceled':
                  // User canceled the upload
                  this.firestore.showSnackBar("Upload was canceled.")
                  console.error("// User canceled the upload")
                  break;
                case 'storage/unknown':
                  // Unknown error occurred, inspect error.serverResponse
                  this.firestore.showSnackBar("Unknown error occurred, inspect error.serverResponse")
                  console.error("Unknown error occurred, inspect error.serverResponse")
                  break;
              }
              this.dialogRef.close(false)
              this.showPDFPreview = false
            }, 
            async () => {
             //   let coverImageURL = uploadTask.snapshot.metadata.fullPath // Upload completed successfully, now we can get the download URL
             //   const storage = getStorage();
              //  const imageRef = ref(storage, coverImageURL);
                this.data.fileType = fileType
              //  getDownloadURL(imageRef)
              //    .then(async (url) => {
               //     coverImageURL = url
                    //this.firestore.updateCoverImage(this.organizationKey, this.projectKey, this.postKey, this.coverImageURL, this.contentType)
                    this.loaderMessage = "Saving file to database..."
                    if (this.userImageUpload == false) {
                    await this.firestore.addImage(this.organizationKey, this.projectKey, this.contentKey, this.contentType, this.userId, uploadTask.snapshot.metadata.name, uploadTask.snapshot.metadata.fullPath, uploadTask.snapshot.metadata.contentType as string, this.doAddCover, this.textContent, projectName, this.objectType).then(async ( result) => {
                      this.loaderMessage = "File is added to database. Reading its content..."
                      if (this.contentKey == "" && result != undefined && result != "") {
                        this.contentKey = result
                      }
                      this.firestore.showSnackBar("The file has been uploaded.")
                          if (result) {
                            this.data.documentKey = result
                            this.fileKey = result
                            if (this.fileType.startsWith("application/vnd.openxmlformats-officedocument") || this.fileType.startsWith("application/msword") || this.fileType.startsWith("application/vnd.ms-excel") || this.fileType.startsWith("application/vnd.ms-powerpoint")) {
                              this.searchService.extractTextFromOfficeFiles(downloadURL).then((text: any) => {
                                this.data.textContent = text
                                this.dialogRef.close(this.data)
                              })
                            } else if (this.doMakeAudioTranscription == true && (fileType.startsWith("audio") || fileType.startsWith("video"))) {
                              if (fileType.startsWith("audio")) {
                                this.loaderMessage = "Transcribing audio file to text..."
                                const textContent = await this.getGeminiAudioTranscription(downloadURL, fileType).then((result) => {
                                  this.loaderMessage = "Audio file transcribed to text."
                                  return result as string
                                })
                                this.textContent = this.trimTextContent(textContent)
                                this.loaderMessage = "Saving transcription to database..."
                                this.data.textContent = textContent
                                this.dialogRef.close(this.data)
                              } else if (fileType.startsWith("video")) {
                                this.loaderMessage = "Transcribing video file to text..."
                                const textContent = await this.getGeminiAudioTranscription(downloadURL, fileType).then((result) => {
                                  this.loaderMessage = "Video file transcribed to text."
                                  return result as string
                                })
                                this.textContent = this.trimTextContent(textContent)
                                this.loaderMessage = "Saving transcription to database..."
                                this.data.textContent = textContent
                                this.dialogRef.close(this.data)
                              }

                            } else if (this.fileType == "application/pdf") {
                              await this.firestore.savePDFImage(this.textTitle, this.fileKey, this.organizationKey, this.userId, this.contentKey, url)// saves cover image of pdf file
                              this.data.textContent = this.textContent
                              this.data.coverImageURL = downloadURL
                              this.dialogRef.close(this.data)
                            } else if (this.fileType && this.fileType.startsWith("image")) {
                              if (this.contentKey != "") {
                              this.firestore.updateContentCoverImage(this.organizationKey, this.contentKey, url).then(() => {
                                this.data.coverImageURL = downloadURL
                                this.dialogRef.close(this.data)
                              }).catch((error) => {
                                console.error("error", error)
                                this.dialogRef.close(false)
                              })
                            } else {
                              this.dialogRef.close(false)
                            }
                            } else {
                              this.data.coverImageURL = downloadURL
                              this.dialogRef.close(this.data)
                            }
                          } else {
                            this.data.coverImageURL = downloadURL
                            this.dialogRef.close(this.data)
                          }
                        }).catch((error) => {
                          console.error("error", error)
                          this.dialogRef.close(false)
                       //   this.isLoadingLabelVisible = false
                        })
                      } else { // user is uploading image for profile
                        this.data.coverImageURL = downloadURL
                        this.dialogRef.close(this.data)
                      }
                  })
            }
      //    )
   //     }
      }})
  }

  async getGeminiAudioTranscription(path: string, fileType: string) {
    const result = await this.searchService.getGeminiAudioTranscription(path, fileType)
    return result
  }

  trimTextContent(textContent: string) {
    const maxLength = 900000
    if (textContent.length > maxLength) {
      textContent = textContent.substring(0, maxLength)
      this.firestore.showSnackBar("Text content of the file has been truncated to " + maxLength + " characters.")
    }
    return textContent
  }

}
